import type { ClinicDetailResponse } from '@/types'

export function useClinic(slug: string | Ref<string>) {
  const slugRef = isRef(slug) ? slug : ref(slug)
  const key = computed(() => `clinic-${slugRef.value}`)

  return useAsyncData<{ success: boolean; data: ClinicDetailResponse }>(
    key,
    () => $fetch(`/api/clinics/${slugRef.value}`),
    {
      watch: [slugRef],
    }
  )
}
